<!-- 由 suu 创建于 2022-08-26 星期五 -->
<!-- 美图秀秀福利H5海报 -->
<template>
  <div class="mtxx-h5">
    <img
      class="mt-bg"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/mtxxh5-bg"
      alt=""
    />
    <div class="mt-btn user-btn" @click="handleClick">立即领取</div>
  </div>
</template>

<script>
export default {
  name: 'mtxx-h5',

  components: {},

  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {
    this.$buryPoint('MTXX_H5_SHOW', {})
  },

  destroyed() {},

  methods: {
    handleClick() {
      this.$buryPoint('MTXX_H5_CLICK', {})
      setTimeout(() => {
        location.href = 'http://t.weimob.com/ECiOZ'
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.mtxx-h5 {
  position: relative;
  .mt-bg {
    width: 100vw;
    display: block;
  }
  .mt-btn {
    width: 343px;
    height: 48px;
    background: #ff2071;
    border-radius: 25px;
    position: absolute;
    top: 314px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    font-weight: 500;
    color: #fff;
  }
  .user-btn:active {
    transform: translateX(-50%) scale(0.95);
  }
}
</style>
